import * as $ from "jquery";
import * as _ from "lodash";
import { ReportFilesCollection } from "../../collections/ReportFiles";
import { ReportsCollection } from "../../collections/Reports";
import { BaseInternalView, BaseInternalViewOptions } from "../_BaseViews";
import { ModifyReportModal } from "../modals/reports/ModifyReportModal";
import { RootReportView } from "./RootReportView";

declare var App: any;

export interface ReportsViewOptions extends BaseInternalViewOptions {
}

export class ReportsView extends BaseInternalView {

    private template = _.template(require("../../templates/reports/reports.html"));
    private subViews: RootReportView[] = [];
    private orgId: number;

    private reportFilesCollection: ReportFilesCollection;
    private reportsCollection: ReportsCollection = new ReportsCollection();

    constructor(options: ReportsViewOptions) {
        super(<any> _.extend({
            events: {
                'click .new-reports-button': 'showCreateReportModal',
            }
        }, options));
    }

    private ensureCollectionsLoaded () {
        var outerDeferred = $.Deferred();
        $.when(
            this.reportsCollection.getCollectionFetchPromise(),
            this.reportFilesCollection.getCollectionFetchPromise()
        ).then(() => {
            outerDeferred.resolve();
        });
        return outerDeferred;
    }

    render () {
        this.renderMain(false);
        $.when(this.ensureCollectionsLoaded())
            .then(() => {
                this.setNavPriorityIds();
                this.renderMain(true, this.orgId);
                var reports = this.reportsCollection.where({
                    'organization_id': this.orgId
                });
                _.each(reports, (report) => {
                    this.renderRootReportView(report);
                });
            });

        return this;
    }

    show(orgId) {
        // Get organization id from the router
        this.orgId = orgId;
        this.reportFilesCollection = new ReportFilesCollection([], {
            organizationId: this.orgId
        });
        this.render();
    }

    private renderMain (collectionLoaded, currentOrganizationId?: number) {
        this.$el.html(this.template({
            permissionCollection: this.options.permissionCollection,
            reportsCollection: this.reportsCollection,
            orgId: this.orgId,
            currentOrg: this.options.organizationCollection.findWhere({'id': currentOrganizationId}),
            collectionLoaded: collectionLoaded,
            banner: require('../../../img/senseware/landing-page-reports.svg'),
        }));
    }

    private showCreateReportModal () {
        var view = new ModifyReportModal(_.extend({
            isClone: false,
            parentView: this,
            modelId: null,
            reportId: null,
            reportsCollection: this.reportsCollection,
            orgId: this.orgId
        }, this.options));
        $('.modals').append(view.render().el);
        view.show();
    }

    private renderRootReportView(report: Backbone.Model) {
        var rootReportView = new RootReportView(_.extend(this.options, {
            reportsCollection: this.reportsCollection,
            reportFilesCollection: this.reportFilesCollection,
            report: report,
            orgId: this.orgId
        }));
        this.subViews.push(rootReportView);
        this.$('.root-reports').append(rootReportView.render().el);
    }

    private setNavPriorityIds() {
        App.Bus.trigger('priority:reportOrganizations', [this.orgId]);
    }

    remove() {
        while (this.subViews.length) this.subViews.pop().remove();
        // But also do what the super view would normally do
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/reports/ReportsView.ts